/* eslint-disable import/prefer-default-export */
export const etcInfoDefine = {
  CONFIG_CHANGE_HIST: 'CONFIG_CHANGE_HIST',
  SERVER_MAJOR_PROC: 'SERVER_MAJOR_PROC',
  SERVER_APPLOG: 'SERVER_APPLOG',
  NETDEVICE_MODULE: 'NETDEVICE_MODULE',
  NETDEVICE_POWER: 'NETDEVICE_POWER',
  NETDEVICE_FAN: 'NETDEVICE_FAN',
  NETDEVICE_CONFIG_CHANGE_HIST: 'NETDEVICE_CONFIG_CHANGE_HIST',
  NETDEVICE_INTERFACE: 'NETDEVICE_INTERFACE',
  NETDEVICE_SYSLOG: 'NETDEVICE_SYSLOG',
  POE_PORT_POWER: 'POE_PORT_POWER',
  WIRELESS_AP_CLIENT: 'WIRELESS_AP_CLIENT',
  WIRELESS_AP: 'WIRELESS_AP',
};



// WEBPACK FOOTER //
// ./src/components/popup/FaultAnalysisPopup/constants/fault-analysis.js